import React, {Component} from 'react';
import TitleContent from './title-content';
import ButtonGroupContent from './button-group-content';
import RichTextContent from './rich-text-content';
import ArticleContent from './article-content';
import ImageContent from './image-content';
import AudioContent from './audio-content';
import VideoContent from './video-content';
import SocialMediaLinksContent from './social-media-links-content';
import './content.css';

/** @class Content
 * A factory component which renders specific booth
 * content items based on their type property.
 */
export default class Content extends Component {

  /** @function
   * Renders the content component.
   */
  render() {
    switch(this.props.type){
      case 'title':
        return (
          <div className={`grid-item grid-cols-${this.props.columns}`}>
            <TitleContent {...this.props} />
          </div>
        );
      case 'button-group':
        return (
          <div className={`grid-item grid-cols-${this.props.columns}`}>
            <ButtonGroupContent {...this.props} />
          </div>
        );
      case 'rich-text':
        return (
          <div className={`grid-item grid-cols-${this.props.columns}`}>
            <RichTextContent {...this.props} />
          </div>
        );
      case 'article':
        return (
          <div className={`grid-item grid-cols-${this.props.columns} interactive`}>
            <ArticleContent {...this.props} />
          </div>
        );
      case 'image':
        return (
          <div className={`grid-item grid-cols-${this.props.columns} interactive`}>
            <ImageContent {...this.props} />
          </div>
        );
      case 'audio':
        return (
          <div className={`grid-item grid-cols-${this.props.columns} interactive`}>
            <AudioContent {...this.props} />
          </div>
        );
      case 'video':
        return (
          <div className={`grid-item grid-cols-${this.props.columns} interactive`}>
            <VideoContent {...this.props} />
          </div>
        );
      case 'social-media-links':
        return (
          <div className={`grid-item grid-cols-${this.props.columns}`}>
            <SocialMediaLinksContent {...this.props} />
          </div>
        );
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/content/content.js